module.exports = __webpack_public_path__ + "e8d61d0972528623bc610d87590bc20d.svg";